<template>
  <div>
    <h2>Quantidade de pedidos: {{ quantidadePedidos }}</h2>
    <h2>Valor bruto: R$ {{ formatValor(valorBruto) }}</h2>
    <h2>Taxa de entrega dos pedidos: R$ {{ formatValor(taxaEntregaPedidos) }}</h2>
    <h2>Valor líquido: R$ {{ formatValor(valorLiquido) }}</h2>
    <h2>Ticket médio: R$ {{ formatValor(ticketMedio) }}</h2>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
    >
      <template v-slot:items="{ item }">
        <td>{{ item.cliente }}</td>
        <td>{{ formatTexto(item.aparelho) }}</td>
        <td>{{ formatStatusPedido(item.status_pedido) }}</td>
        <td>{{ formatTipo(item.tipo) }}</td>
        <td>
          <v-icon v-if="item.com_cupom" color="green">check_circle</v-icon>
          <v-icon v-else color="red">remove_circle</v-icon>
        </td>
        <td>{{ formatData(item.data) }}</td>
        <td>{{ formatValor(item.valor_bruto) }}</td>
        <td>{{ formatValor(item.taxa_delivery) }}</td>
        <td>{{ formatValor(item.valor_liquido) }}</td>
      </template>
      <template v-slot:no-data>
        <h1>Nenhum pedido encontrado</h1>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { formatDatetime } from '../utils/data'

export default {
  name: 'PedidosTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Cliente',
          value: 'cliente',
          align: 'left',
          sortable: true
        },
        {
          text: 'Aparelho',
          sortable: false
        },
        {
          text: 'Status',
          sortable: false
        },
        {
          text: 'Tipo',
          sortable: false
        },
        {
          text: 'Cupom',
          sortable: false
        },
        {
          text: 'Data',
          value: 'data'
        },
        {
          text: 'Valor Brt',
          value: 'valor_bruto'
        },
        {
          text: 'Taxa Delivery',
          value: 'taxa_delivery'
        },
        {
          text: 'Valor Liq',
          value: 'valor_liquido'
        }
      ],
      quantidadePedidos: 0,
      valorBruto: 0,
      taxaEntregaPedidos: 0,
      valorLiquido: 0,
      ticketMedio: 0
    }
  },
  watch: {
    items() {
      let quantidadePedidos = this.items.length
      let valorBruto = 0
      let taxaEntregaPedidos = 0
      let valorLiquido = 0
      for (let i = 0; i < quantidadePedidos; i ++) {
        const e = this.items[i]
        valorBruto += e.valor_bruto
        taxaEntregaPedidos += e.taxa_delivery
        valorLiquido += e.valor_liquido
      }
      this.quantidadePedidos = quantidadePedidos
      this.valorBruto = valorBruto
      this.taxaEntregaPedidos = taxaEntregaPedidos
      this.valorLiquido = valorLiquido
      this.ticketMedio = quantidadePedidos > 0 ? valorLiquido / quantidadePedidos : 0
    }
  },
  methods: {
    formatData(value) {
      return formatDatetime(value)
    },
    formatValor(value) {
      let d = value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      d = d.replace('R$', '').trim()
      return d
    },
    formatTexto(value) {
      if (value === null) {
        return '---'
      }
      return value
    },
    formatTipo(value) {
      switch (value) {
        case 0:
          return 'Mesa'
        case 1:
          return 'Delivery'
        case 2:
          return 'Comanda Fácil'
        default:
          return '---';
      }
    },
    formatStatusPedido(value) {
      switch (value) {
        case 0:
          return 'Recusado'
        case 1:
          return 'Atendido'
        case 2:
          return 'Pendente'
        case 3:
          return 'Saiu para entrega'
        case 4:
          return 'Entregue'
        case 5:
          return 'Cancelado'
        case 6:
          return 'Erro no pagamento'
        default:
          return '---';
      }
    }
  }
}
</script>
